import { render, staticRenderFns } from "./customCommon.vue?vue&type=template&id=62a09ba8&scoped=true&"
import script from "./customCommon.vue?vue&type=script&lang=js&"
export * from "./customCommon.vue?vue&type=script&lang=js&"
import style0 from "./customCommon.vue?vue&type=style&index=0&id=62a09ba8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a09ba8",
  null
  
)

export default component.exports